module.exports = ".sidebar-header {\n  text-shadow: 2px 2px 10px #4744e8;\n  font-weight: 600; }\n\n.sidebar-content .nav-container ul.navigation li {\n  text-shadow: 2px 2px 10px #4744e8; }\n\n.sidebar-content .nav-container ul.navigation li .menu-title {\n    font-size: 12px;\n    font-weight: 600; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.component.scss
// module id = ./src/app/shared/sidebar/sidebar.component.scss
// module chunks = main